export default {
  subtitle: {
    id: 'customer_care_fail_loading_screen_subtitle',
    defaultMessage: 'Please give us a sec and then give it another go.',
  },
  title: {
    id: 'customer_care_fail_loading_screen_title',
    defaultMessage: 'Something went wrong',
  },
  tryAgainCta: {
    id: 'dashboard_diagnosis_fail_loading_retry',
    defaultMessage: 'Try again',
  },
}
